<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2024-12-26 16:13:00
 * @LastEditors: lc
 * @LastEditTime: 2025-05-12 08:54:15
-->
<template>
  <div class="studylevellog-list">
    <Table border
           stripe
           :columns="columns1"
           ref="selection"
           :data="typelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加 弹层 -->
    <Drawer title="信息"
            v-model="showCreatTypeModal"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="cate"
            ref="addCate"
            :rules="cateValidate"
            action="javascript:void(0)">
        <FormItem label="勋章样例图">
          <upload-thumb v-model="cate.xunzhang"
                        ref="uploadthumb1"
                        :defaultList="thumblist1"
                        :autoCropWidth="164"
                        :autoCropHeight="164"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:164*164,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="证书样例图">
          <upload-thumb v-model="cate.zhengshu"
                        ref="uploadthumb2"
                        :defaultList="thumblist2"
                        :autoCropWidth="212"
                        :autoCropHeight="156"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:212*156,大小不超过2M'"></upload-thumb>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showCreatTypeModal = false">取消</Button>
        <Button type="primary"
                :loading="tijiaoloading"
                @click="createType('addCate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>
        
        <script>
import UploadThumb from "../common/thumb";
import UploadThumb2 from "../common/thumb";
export default {
  name: "studylevellog-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      tijiaoloading: false,
      fileList: [],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      type_list: [{ id: 1, name: '文件' }, { id: 2, name: '视频' }],
      // 类别
      cate: {
        name: "", // 当前类别
        thumb: "", // 排序
        type: 1
      },
      formItem: {},
      thumblist1: [],
      thumblist2: [],
      // 类别 规则
      cateValidate: {
        name: [
          {
            required: true,
            message: "名称必须填写",
            trigger: "blur"
          }
        ]
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "用户",
          minWidth: 120,
          key: "username",
        },
        {
          title: "学生姓名",
          minWidth: 120,
          key: "name",
        },
        {
          title: "学生身份证号",
          minWidth: 120,
          key: "idcrad",
        },
        {
          title: "收货姓名",
          minWidth: 120,
          key: "receipt_name",
        },
        {
          title: "收货电话",
          minWidth: 120,
          key: "receipt_phone",
        },
        {
          title: "收货地址",
          minWidth: 120,
          key: "receipt_address",
        },
        {
          title: "上传证书",
          key: "action",
          minWidth: 130,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.is_upload_zhengshu == "0" ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "上传"
              ),
            ]);
          }
        }
      ],
      typelist: [], //类别列表
      showCreatTypeModal: false,
      currentId: 0, // 编辑类别，当前类别id
      levelid: 0,
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    this.levelid = this.$route.params.id;
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb,
    UploadThumb2,
  },
  methods: {
    // 获取类别列表
    getTableList: function () {
      var self = this;
      var params = {
        page: this.pages.page,
        size: this.pages.size,
        level_id: this.levelid,
      };
      this.$api.studylevellog.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.typelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var params = {
        page: this.pages.page,
        size: this.pages.size,
        level_id: this.levelid,
      };
      this.$api.studylevellog.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.typelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 编辑类别
    editType: function (id) {
      this.currentId = id;
      this.showCreatTypeModal = true;
      this.tijiaoloading = false;
      this.thumblist1 = new Array();
      this.thumblist2 = new Array();
    },
    // 提交新类别
    createType: function (name) {
      this.tijiaoloading = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb1"].uploadList.length > 0) {
            this.cate.xunzhang = this.$refs["uploadthumb1"].uploadList[0].url;
          } else {
            this.cate.xunzhang = null;
          }
          if (this.$refs["uploadthumb2"].uploadList.length > 0) {
            this.cate.zhengshu = this.$refs["uploadthumb2"].uploadList[0].url;
          } else {
            this.cate.zhengshu = null;
          }
          let params = {
            zhengshu: this.cate.zhengshu,
            xunzhang: this.cate.xunzhang,
            log_id: this.currentId,
          };
          this.$api.studylevellog.edit(params).then(res => {
            this.tijiaoloading = false;
            if (res.code == 200) {
              this.showCreatTypeModal = false;
              this.getTableList();
            }
          });
          this.tijiaoloading = false;
          this.$nextTick(() => {
            this.tijiaoloading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.tijiaoloading = false;
          this.$nextTick(() => {
            this.tijiaoloading = true;
          });
        }
      });
      this.tijiaoloading = false;
    },
  }
};
        </script>